import React from "react";
import { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap'
// import { Link } from "gatsby";
import  heroImage from "../images/hero-career-adv-4.webp"

export default function Hero() {

    const [navbar, setNavbar] = useState('position__top');
    const changeBackground = () => {
        //console.log(window.scrollY)
        if (window.scrollY >= 80) {
            setNavbar('position__scroll')
        } else {
            setNavbar('position__top')
        }
    }

    useEffect(() => {
        changeBackground()
        // adding the event when scroll change background
        window.addEventListener("scroll", changeBackground)
    })

    return (
        <>
            <Container fluid className="hero">
            <img className="w-100" src={heroImage} alt="Hero" loading="lazy"/>
                <Container className="headline">
                    <Row>
                        <Col>
                            {/* <h2><span>Career Advancement</span> empowers UChicago undergraduates of all interests and backgrounds to apply their <span>world-class education to a fulfilling career</span>.</h2> */}

                            <h2><span>Career Advancement</span> Guiding UChicago undergraduate students from classroom to career.</h2>
                            </Col>
                    </Row>
                </Container>
            </Container>
        </>
    )
}